import React, { createContext, useContext } from 'react';
var INITIAL_CONTEXT = {
    posts: undefined,
    loading: false,
    error: '',
    refetch: function () { return null; },
    reset: function () { return null; }
};
var PostCommentsContext = createContext(INITIAL_CONTEXT);
export var usePostCommentsContext = function () {
    return useContext(PostCommentsContext);
};
export default PostCommentsContext;
//# sourceMappingURL=PostCommentsContext.js.mapimport React, { createContext, useContext } from 'react';
var INITIAL_CONTEXT = {
    posts: undefined,
    loading: false,
    error: '',
    refetch: function () { return null; },
    reset: function () { return null; }
};
var PostCommentsContext = createContext(INITIAL_CONTEXT);
export var usePostCommentsContext = function () {
    return useContext(PostCommentsContext);
};
export default PostCommentsContext;
//# sourceMappingURL=PostCommentsContext.js.map